/* -----------------------------------------------------------------------------
 * Wizard SM Mutations
 *
 * @description - Mutations of Wizard SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

export default {

  /**
   * Set switched route info
   * @description Sets switched route info
   * @param {Object} state - Wizard SM state
   * @param {String} name - Route name
   * @param {Number} idx - Route step idx
   */
  SET_SWITCHED_ROUTE_INFO (state, { name, idx }) {
    if (idx > -1) state.stepIdx = idx // remember last step idx
    state.routeName = name
    state.routeStepIdx = idx
    state.lockStepSwitch = true // always shut the gate!!!
  },

  /**
   * Unlock step switch
   * @description Unlocks step switch
   * @param {Object} state - Wizard SM state
   */
  UNLOCK_STEP_SWITCH (state) {
    // temporary open the gate, it will be shuted by SET_SWITCHED_ROUTE_INFO
    state.lockStepSwitch = false
  },

  /**
   * Set current view
   * @description Sets current view component vm link to state
   * @param {Object} state - Wizard SM state
   * @param {Object} vm - Given view component vm
   */
  SET_CURRENT_VIEW (state, { vm }) {
    state.view = vm
  },

  /**
   * Set nav field
   */
  SET_NAV_FIELD (state, { f, v }) {
    state.navigation[f] = v
  },

  /**
   * Reset module
   * @description Resets module state to defaults
   * @param {Object} state - Wizard SM state
   */
  RESET_MODULE (state) {
    state.stepIdx = 0
    state.routeName = ''
    state.routeStepIdx = -1
    state.lockStepSwitch = true // always shut the gate!!!
  }

}
